import axios from "axios"
import {countries} from "./utils/countries"
import {CommonService} from "./services/common.service"
// import cookie from "react-cookies"


const protocol = window.location.protocol
const client = axios.create({ headers: { 'Content-Type': 'application/json'}  })

client.interceptors.request.use(function (config) {
    const contryCode = window.location.pathname.split('/')[1]
    const countryCodeExists = countries[contryCode.toUpperCase()]
    if (countryCodeExists)
        config.headers["X-Country-Code"] = contryCode;
    config.headers['Accept-Language'] = CommonService.getLanguage()
    // config.headers.Authorization = cookie.load('token') ? `Token ${cookie.load('token')}` : ''
    return config;
})

// client.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response) {
//             const response = error.response

//             switch (response.status) {
//                 case 401:
//                     // TODO: Remove cache, session or cookies
//                     localStorage.clear();
//                     window.location.href = '/login'
//                     break
//                 case 400:
//                     return response.data
//                 default:
//                     // The request was made and the server responded with a status code
//                     // that falls out of the range of 2xx
//                     return error.response
//             }


//         } else if (error.request) {
//             console.log(error.request);
//             // The request was made but no response was received
//             // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//             // http.ClientRequest in node.js
//             console.log(error.request)
//         } else {
//             // Something happened in setting up the request that triggered an Error
//             console.log('Error', error.message)
//         }
//         return error

// })

// production mode prod, stage, dev
let env = "prod"

let host = process.env.REACT_APP_PUBLIC_API_URL || ''
let api = process.env.REACT_APP_PUBLIC_API_URL || ''
let port = ''
let sistema = process.env.REACT_APP_PUBLIC_SISTEMA_URL || ''
let storage = process.env.REACT_APP_PUBLIC_STORAGE_URL || ''
if (host) {
    env = "custom"
}
switch (env) {
    case "dev":
        host = 'localhost'
        api = `${protocol}//localhost:8001`
        port = '8001'
        sistema = 'http://sistema.naranti.org'
        storage = "https://s3.us-east-1.amazonaws.com/sistema.naranti"
        break
    case "stage":
        host = 'api.naranti.mx'
        api = `${protocol}//sistema.naranti.org`
        port = ''
        sistema = 'http://sistema.naranti.org'
        storage = "https://s3.us-east-1.amazonaws.com/sistema.naranti"
        break
    case "prod":
        host = 'api.naranti.mx'
        api = `https://sistema.naranti.org`
        port = ''
        sistema = 'https://sistema.naranti.org'
        storage = "https://s3.us-east-1.amazonaws.com/sistema.naranti"
        break
    case "custom":
        break
    default:
        host = 'localhost'
        api = `${protocol}//localhost:8000`
        port = '8000'
        sistema = 'http://sistema.naranti.org'
        storage = "https://s3.us-east-1.amazonaws.com/sistema.naranti"
        break
}

export const DEFAULT = {
    protocol: `${protocol}//`,
    host: `${protocol}//${host}`,
    port: port,
    api: api,
    sistema,
    storage,
    axios: client,
    MAPS_API_KEY: process.env.REACT_APP_PUBLIC_MAPS_API_KEY || 'AIzaSyAfqg4rsHpdm4C9YhJOXZ8lVvkPitfSlBE',
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY || '6LeEYp8rAAAAAKKc6x7fx3yU94xJNBdkH1aVmlMw',
    // api: `${protocol}//${host}:${port}`,
    // api: `${protocol}//${api}`,
}